/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_How_3_DescInputs */

const en_landing_how_3_desc = /** @type {(inputs: Landing_How_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The agent stops at each layer or phase change until you say continue.`)
};

const id_landing_how_3_desc = /** @type {(inputs: Landing_How_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent berhenti tiap ganti layer atau fase sampai kamu bilang lanjut.`)
};

/**
* | output |
* | --- |
* | "The agent stops at each layer or phase change until you say continue." |
*
* @param {Landing_How_3_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const landing_how_3_desc = /** @type {((inputs?: Landing_How_3_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_How_3_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_landing_how_3_desc(inputs)
	return en_landing_how_3_desc(inputs)
});